.menuItem {
    font: var(--font-button-18);
    flex-shrink: 0;
    box-shadow: inset 0 -2px 0 0 var(--color-primary);
    transition: box-shadow 0.2s;

    a {
        display: flex;
        align-items: center;
        height: 100%;
        color: var(--color-contrast);
        text-decoration: none;
        white-space: nowrap;
    }
}

.menuItemSelected {
    box-shadow: inset 0 -2px 0 0 var(--accent);
}
